'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var actionTypes = {
  BLUR: 'rrf/blur',
  CHANGE: 'rrf/change',
  FOCUS: 'rrf/focus',
  RESET: 'rrf/reset',
  VALIDATE: 'rrf/validate',
  SET_DIRTY: 'rrf/setDirty',
  SET_ERRORS: 'rrf/setErrors',
  SET_INITIAL: 'rrf/setInitial',
  SET_PENDING: 'rrf/setPending',
  SET_PRISTINE: 'rrf/setPristine',
  SET_SUBMITTED: 'rrf/setSubmitted',
  SET_SUBMIT_FAILED: 'rrf/setSubmitFailed',
  SET_TOUCHED: 'rrf/setTouched',
  SET_UNTOUCHED: 'rrf/setUntouched',
  SET_VALIDITY: 'rrf/setValidity',
  SET_VALIDATING: 'rrf/setValidating',
  SET_FIELDS_VALIDITY: 'rrf/setFieldsValidity',
  SET_VIEW_VALUE: 'rrf/setViewValue',
  RESET_VALIDITY: 'rrf/resetValidity',
  BATCH: 'rrf/batch',
  NULL: null,
  ADD_INTENT: 'rrf/addIntent',
  CLEAR_INTENTS: 'rrf/clearIntents'
};

exports.default = actionTypes;